import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeCardRegenerateFiltering } from './Pages';

export const EmployeeCardRegenerateRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={EmployeeCardRegenerateFiltering} />
    </Fragment>
)